import cx from "clsx";
import type { JSX, Ref } from "react";

export const Input = function InputWithRef({
  type = "text",
  className,
  ref,
  ...props
}: JSX.IntrinsicElements["input"] & { ref?: Ref<HTMLInputElement> }) {
  return (
    <input
      ref={ref}
      type={type}
      className={cx(
        "input input-bordered",
        { "input-error": props["aria-invalid"] },
        "w-full",
        className,
      )}
      {...props}
    />
  );
};
